document.addEventListener("DOMContentLoaded", ()=> {
   
   const swiper = new Swiper('.product-about-section-images', {
     speed: 300,
     spaceBetween: 10,
     navigation: {
       nextEl: '.product-about-section-btn-next',
       prevEl: '.product-about-section-btn-prev',
     },
     breakpoints: {
       320: {
         slidesPerView: 1.2
       },
       768: {
         slidesPerView: 2.3
       }
     }
   });
   
   const selectElements = document.querySelectorAll('.js-choice');
   selectElements.forEach(el => {
     const fontOptions = [];
     el.querySelectorAll('option').forEach(option => {
       if (option.style && option.style.fontFamily) {
         fontOptions.push({
           value: option.value || option.textContent,
           text: option.textContent,
           font: option.style.fontFamily
         });
       }
     });
     
     const choices = new Choices(el, {
       searchEnabled: false,
       itemSelectText: '',
     });
     
     if (fontOptions.length > 0) {
       setTimeout(() => {
         const choiceItems = choices.dropdown.element.querySelectorAll('.choices__item--choice');
         choiceItems.forEach(item => {
           const fontOption = fontOptions.find(opt => opt.text === item.textContent.trim());
           if (fontOption && fontOption.font) {
             item.style.fontFamily = fontOption.font;
           }
         });
         
         const selectedItem = choices.itemList.element.querySelector('.choices__item--selectable');
         if (selectedItem) {
           const fontOption = fontOptions.find(opt => opt.text === selectedItem.textContent.trim());
           if (fontOption && fontOption.font) {
             selectedItem.style.fontFamily = fontOption.font;
           }
         }
       }, 0);
       
       choices.passedElement.element.addEventListener('choice', function(event) {
         const selectedItem = choices.itemList.element.querySelector('.choices__item--selectable');
         if (selectedItem) {
           const fontOption = fontOptions.find(opt => opt.text === event.detail.choice.label);
           if (fontOption && fontOption.font) {
             selectedItem.style.fontFamily = fontOption.font;
           }
         }
       });
     }
   });
   
   const personalizeButton = document.querySelector('.personalize-button');
   const personalizeWrapper = document.querySelector('.product-personalize-wrapper');
   const personalizeClose = document.querySelector('.product-personalize-close');
   
   if (personalizeButton && personalizeWrapper && personalizeClose) {
     personalizeButton.addEventListener('click', () => {
       personalizeButton.classList.add('active');
       personalizeWrapper.classList.add('active');
       
       if (product && product.variants) {
         const engravingVariant = product.variants.find(variant => {
           return variant.title && variant.title.includes('Engraving') || 
                 (variant.options && variant.options.some(option => 
                   typeof option === 'string' && option.includes('Engraving')));
         });
         
         if (engravingVariant) {
           const variantIdInputs = document.querySelectorAll('.product-variant-id');
           
           variantIdInputs.forEach(input => {
             if (input.closest('.product-personalize-wrapper')) {
               input.value = engravingVariant.id;
             }
           });
         }
       }
     });
     
     personalizeClose.addEventListener('click', () => {
       personalizeButton.classList.remove('active');
       personalizeWrapper.classList.remove('active');
     });
   }
   
   const removeEmojis = (text) => {
     return text.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu, '');
   };
   
   const customizeTextInput = document.getElementById('customize-text');
   const countSymbolElements = document.querySelectorAll('.count-symbol');
   const MAX_CHARS = 50;
   
   if (customizeTextInput && countSymbolElements.length > 0) {
     const updateCharCount = () => {
       const currentText = customizeTextInput.value;
       const textWithoutEmojis = removeEmojis(currentText);
       const remainingChars = MAX_CHARS - currentText.length;
       
       countSymbolElements.forEach(element => {
         element.textContent = remainingChars;
       });
       
       const previewInput = document.getElementById('customize-preview');
       if (previewInput) {
         previewInput.value = textWithoutEmojis;
         
         const fontSelect = document.getElementById('engraving-font');
         if (fontSelect && fontSelect.value) {
           const selectedOption = Array.from(fontSelect.options).find(option => option.value === fontSelect.value || option.textContent === fontSelect.value);
           if (selectedOption && selectedOption.style && selectedOption.style.fontFamily) {
             previewInput.style.fontFamily = selectedOption.style.fontFamily;
           }
         }
       }
     };
     
     updateCharCount();
     
     customizeTextInput.addEventListener('input', () => {
       if (customizeTextInput.value.length > MAX_CHARS) {
         customizeTextInput.value = customizeTextInput.value.substring(0, MAX_CHARS);
       }
       
       updateCharCount();
     });
     
     const fontSelect = document.getElementById('engraving-font');
     if (fontSelect) {
       fontSelect.addEventListener('change', () => {
         updateCharCount();
       });
     }
   }
   
   const personalizeForm = document.querySelector('.product-personalize-wrapper form');
   const personalizeSubmitButton = document.querySelector('.product-form__submit-personalize');
   
   if (personalizeForm && customizeTextInput && personalizeSubmitButton) {
     const validatePersonalization = () => {
       const isValid = customizeTextInput.value.trim().length > 0;
       
       if (isValid) {
         customizeTextInput.classList.remove('error');
         personalizeSubmitButton.disabled = false;
       } else {
         customizeTextInput.classList.add('error');
         personalizeSubmitButton.disabled = true;
       }
       
       return isValid;
     };
     
     validatePersonalization();
     
     customizeTextInput.addEventListener('input', validatePersonalization);
     
     personalizeForm.addEventListener('submit', (event) => {
       if (!validatePersonalization()) {
         event.preventDefault();
         event.stopPropagation();
         
         const errorMessage = document.querySelector('.product-personalize-wrapper .product-form__error-message');
         if (errorMessage) {
           errorMessage.textContent = 'Please enter text for personalization';
           errorMessage.parentElement.removeAttribute('hidden');
         }
         
         customizeTextInput.focus();
       }
     });
   }
  });